export default "__VITE_ASSET__CXC1Xftn__"